import AvailableSessionErrorWrapper from "./AvailableSessionErrorWrapper";

export const NoLocationSelected: React.FC = () => {
	return (
		<AvailableSessionErrorWrapper>
			Select a location to view sections available on campus.
		</AvailableSessionErrorWrapper>
	);
};

export default NoLocationSelected;
